<template>
  <div class="introduce">
    <div class="banner">
      <div class="banner-center center">
        <div class="banner-info">
          <div class="btn shenqing bgRed" @click="openDialog('免费试用', 0)">
            申请试用
          </div>
        </div>
      </div>
    </div>
    <div class="item_1" id="intro">
      <div class="item-title">
        <h3 class="title2">企业介绍</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents center">
        <div class="info">
          <span class="info-logo"></span>
          易知鸟，是一款基于云端技术研发，致力于为数百万教育培训机构提供集招生、营销、管理、运营、家校互通等服务于一体的智慧教育云服务平台。以“用科技和热爱成就每个教培机构”为使命，助力教育培训机构实现数字化运营和智慧化管理，推动教育产业健康发展。
        </div>
      </div>
    </div>
    <div class="item_2" id="culture">
      <div class="item-title">
        <h3 class="title2">企业文化</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents center">
        <ul>
          <li
            v-for="(x, index) in item2_list"
            :class="'item2_bg_' + (index + 1)"
          >
            <div class="logo">
              <img
                :src="
                  '/static/img/aboutUs_intro/guanyu_jieshao_icon_0' +
                    (index + 1) +
                    '.png'
                "
                alt=""
              />
            </div>
            <div class="info">{{ x.info }}</div>
            <div class="title">{{ x.title }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="item_5" id="rongyu">
      <div class="item-title">
        <h3 class="title2">企业荣誉</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents center">
        <ul>
          <li class="left">
            <img src="/static/img/aboutUs_intro/zheng_1.png" alt="" />
          </li>
          <li class="left">
            <img
              src="/static/img/aboutUs_intro/zheng_5.jpg"
              style="max-width: 100%;height: 100%;"
              lt=""
            />
          </li>
          <li class="right">
            <img src="/static/img/aboutUs_intro/zheng_3.png" alt="" />
          </li>
          <li class="right">
            <img src="/static/img/aboutUs_intro/zheng_2.png" alt="" />
          </li>
          <li class="right">
            <img src="/static/img/aboutUs_intro/zheng_4.png" alt="" />
          </li>
        </ul>
      </div>
    </div>
    <div class="item_3" id="team">
      <div class="item-title">
        <h3 class="title2">团队风采</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents center">
        <ul class="team">
          <li>
            <ul class="team-top">
              <li class="left">
                <img
                  src="https://cdntest.yizhiniao.com/newWebsite_/aboutUs_intro/team2.jpg?=1"
                  alt=""
                />
              </li>
              <li class="right">
                <ul class="">
                  <li>
                    <img
                      src="https://cdntest.yizhiniao.com/newWebsite_/aboutUs_intro/team1.jpg?=1"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      src="https://cdntest.yizhiniao.com/newWebsite_/aboutUs_intro/nianhui2.jpg?=1"
                      alt=""
                    />
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <ul class="team-bottom">
              <li>
                <img
                  src="https://cdntest.yizhiniao.com/newWebsite_/aboutUs_intro/nianhui1.jpg?=1"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="https://cdntest.yizhiniao.com/newWebsite_/aboutUs_intro/team5.jpg?=1"
                  alt=""
                />
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <div class="item_4" id="concat">
      <div class="item-title">
        <h3 class="title2">联系我们</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents center">
        <div class="map-content">
          <ul>
            <li class="map" id="contactAddr"></li>
            <li>
              <ul class="info">
                <li class="name">
                  <h5>公司名称：</h5>
                  <p>浙江筑森网络科技有限公司</p>
                </li>
                <li class="address">
                  <h5>公司地址：</h5>
                  <p>浙江省杭州市拱墅区湖州街567号北城天地</p>
                </li>
                <li class="phone">
                  <h5>网址：</h5>
                  <p>www.chosien.com</p>
                  <h5>邮箱：</h5>
                  <p>market@chosien.com</p>
                  <h5>服务热线：</h5>
                  <p>0571-85789582 133-6289-3918</p>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <shen-qing></shen-qing>
  </div>
</template>
<script>
import shenQing from "./shenqing.vue";
export default {
  components: {
    shenQing
  },
  data() {
    return {
      fromFooter: false,
      map: null,
      marker: null,
      item2_list: [
        { title: "我们的口号", info: "“ 轻松办学，智慧教育 ”" },
        { title: "愿景", info: "“ 成为教培行业可敬可爱的科技赋能伙伴 ”" },
        { title: "使命", info: "“ 用科技和热爱成就每个教培机构 ”" },
        { title: "价值观", info: "“ 诚实，进取，专业，成就客户 ”" }
      ]
    };
  },
  created() {
    let query = JSON.parse(localStorage.getItem("current"));
    if (this.fromFooter) return;
    this.$nextTick(() => {
      this.getlocal(query);
      this.fromFooter = true;
    });
  },
  mounted() {
    // const s = document.createElement('script');
    // s.type = 'text/JavaScript';
    // s.src = 'https://webapi.amap.com/maps?v=1.3&key=816afd8e181bc83c46f9a4c91b4a0c1e';
    // document.body.appendChild(s);
    this.init();
    this.$nextTick(function() {
      window.addEventListener("scroll", this.handleScroll);
    });
  },
  watch: {
    $route(data) {
      this.$nextTick(() => {
        this.getlocal(data.query);
      });
    }
  },
  methods: {
    init: function() {
      this.map = new AMap.Map("contactAddr", {
        resizeEnable: true,
        zoom: 11,
        center: [120.124, 30.32135]
      });
      this.marker = new AMap.Marker({
        map: this.map,
        position: [120.124, 30.32135],
        icon: new AMap.Icon({
          size: new AMap.Size(40, 50), //图标大小
          image: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
          imageOffset: new AMap.Pixel(0, 0)
        })
      });
      // 设置label标签
      this.marker.setLabel({
        //label默认蓝框白底左上角显示，样式className为：amap-marker-label
        offset: new AMap.Pixel(-59, -40), //修改label相对于maker的位置
        content:
          '<div class="mapMarker"><span style="font-weight:600;">湖州街567号北城天地</span><span>&nbsp;&nbsp;>附近</span></div>'
      });
    },
    getlocal(data) {
      let targ = data ? data.top : undefined;
      let anel = document.getElementById(targ);
      if (targ) {
        anel.scrollIntoView();
      }
    },
    openDialog: function(title, type) {
      //type:(0机构,1微官网)
      this.$parent.$refs.openPop.openDialog(title, type);
    }
  }
};
</script>

<style scoped lang="less">
/deep/.amap-marker-label {
  position: absolute;
  z-index: 2;
  border: 1px solid #ccc;
  background-color: white;
  white-space: nowrap;
  cursor: default;
  padding: 10px;
  font-size: 12px;
  line-height: 14px;
  box-shadow: 0px 2px 40px 0px #f1f1f1;
}
.banner {
  width: 100%;
  height: 480px;
  margin-top: 80px;
  background: url("https://cdntest.yizhiniao.com/newWebsite_/aboutUs_intro/guanyu_jieshao_banner_1.jpg")
    no-repeat center;

  .banner-center {
    height: 100%;
    position: relative;
  }

  .banner-info {
    position: absolute;
    bottom: 120px;
    left: 40px;
    text-align: left;
  }
}
.item_1 {
  padding-top: 180px;
  .item-contents {
    .info-logo {
      width: 110px;
      height: 37px;
      background: url("/static/img/common/head-logo.png") no-repeat center;
      background-size: 100%;
    }
    padding: 80px 89px 0 111px;
    .info {
      font-size: 20px;
      line-height: 40px;
      text-align: left;
    }
  }
}
.item_2 {
  padding-top: 180px;
  .item-contents {
    padding-top: 80px;
    ul {
      width: 100%;
      height: 520px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        width: 565px;
        height: 250px;
        padding-top: 80px;
        transition: all 1s;
        .logo {
          width: 270px;
          height: 40px;
          margin: 0 auto 10px;
          visibility: visible;
          opacity: 1;
        }
        .info {
          visibility: hidden;
          opacity: 0;
          transition: all 1s;
        }
        .title {
          text-align: center;
          color: #fff;
          font-size: 28px;
          line-height: 40px;
        }
        &:hover {
          .logo {
            display: none;
            visibility: hidden;
            opacity: 0;
          }
          .info {
            visibility: visible;
            opacity: 1;
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            margin: 0 auto 20px;
            color: #fff;
          }
          .title {
            color: rgba(255, 255, 255, 0.5);
          }
          &.item2_bg_1 {
            background: url(https://cdntest.yizhiniao.com/newWebsite_/aboutUs_intro/guanyu_jieshao_011.png?t=11)
              no-repeat center;
          }
          &.item2_bg_2 {
            background: url(https://cdntest.yizhiniao.com/newWebsite_/aboutUs_intro/guanyu_jieshao_022.png?t=11)
              no-repeat center;
          }
          &.item2_bg_3 {
            background: url(https://cdntest.yizhiniao.com/newWebsite_/aboutUs_intro/guanyu_jieshao_033.png?t=11)
              no-repeat center;
          }
          &.item2_bg_4 {
            background: url(https://cdntest.yizhiniao.com/newWebsite_/aboutUs_intro/guanyu_jieshao_044.png?t=11)
              no-repeat center;
          }
        }
      }
      li.item2_bg_1 {
        background: url(https://cdntest.yizhiniao.com/newWebsite_/aboutUs_intro/guanyu_jieshao_01.png?t=11)
          no-repeat center;
      }
      li.item2_bg_2 {
        background: url(https://cdntest.yizhiniao.com/newWebsite_/aboutUs_intro/guanyu_jieshao_02.png?t=11)
          no-repeat center;
      }
      li.item2_bg_3 {
        background: url(https://cdntest.yizhiniao.com/newWebsite_/aboutUs_intro/guanyu_jieshao_03.png?t=11)
          no-repeat center;
      }
      li.item2_bg_4 {
        background: url(https://cdntest.yizhiniao.com/newWebsite_/aboutUs_intro/guanyu_jieshao_04.png?t=11)
          no-repeat center;
      }
    }
  }
}
.item_3 {
  padding-top: 180px;
  .item-contents {
    padding-top: 80px;
    .team {
      width: 1160px;
      height: 840px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      li {
        /* border:1px solid; */
        overflow: hidden;
        img {
          width: 100%;
        }
      }
      > li {
        width: 100%;
        > ul {
          display: flex;
          justify-content: space-between;
        }
        .team-top {
          width: 100%;
          height: 460px;
          > li.left {
            width: 740px;
            height: 100%;
          }
          > li.right {
            width: 400px;
            height: 100%;
            ul {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: space-between;
              flex-direction: column;
              > li {
                width: 100%;
                height: 220px;
              }
            }
          }
        }
        .team-bottom {
          width: 100%;
          height: 358px;
          li {
            width: 570px;
            height: 100%;
          }
        }
      }
    }
  }
}
.item_4 {
  padding: 180px 0 180px;
  .item-contents {
    padding-top: 80px;
    .map-content {
      width: 1160px;
      height: 460px;
      ul {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .map {
          width: 740px;
          height: 460px;
          border: 1px solid #e3e3e3;
        }

        .info {
          width: 400px;
          height: 460px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          li {
            width: 398px;
            padding: 17px 20px;
            background: #f8f8f8;
            border: 1px solid #e3e3e3;
            h5 {
              font-size: 16px;
              line-height: 32px;
              color: #1e1e1e;
              text-align: left;
              font-weight: 600;
              margin: 0;
            }
            p {
              font-size: 16px;
              line-height: 32px;
              color: #1e1e1e;
              text-align: left;
            }
            /* &:last-child{
                                padding:12px 20px;
                                p{
                                    font-size:16px ;
                                    line-height: 22px;
                                    color: #1e1e1e;
                                    text-align: left;
                                }
                            } */
          }
          li.name {
            height: 98px;
          }
          li.address {
            height: 128px;
          }
          li.phone {
            padding: 12px 20px;
            height: 190px;
            h5 {
              line-height: 28px;
            }
            p {
              line-height: 28px;
              margin: 0;
            }
          }
        }
      }
    }
    .amap-marker-label {
      border: none;
      padding: 5px 10px;
      border-radius: 2px;
      box-shadow: 3px 3px 4px #777777;
    }
  }
}
.item_5 {
  padding: 180px 0 0;
  .item-contents {
    padding-top: 80px;
    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    li.left {
      width: 100%;
      height: 540px;
      margin-bottom: 10px;
    }
    .right {
      width: 377px;
      height: 540px;
      img {
        max-width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs_intro.vue